var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("h2", [_vm._v(_vm._s(_vm.$t("pages.permission.data")))]),
    _c(
      "form",
      { staticClass: "permission-form mt-3" },
      [
        _c("suc-form-has-error", { attrs: { form: _vm.form } }),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6" },
            [
              _c("vacation-start-day-field", {
                attrs: {
                  id: "vacation-start-date",
                  name: "dateStart",
                  form: _vm.form,
                  required: true,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6" },
            [
              _c("vacation-end-day-field", {
                attrs: {
                  id: "vacation-end-date",
                  name: "dateEnd",
                  form: _vm.form,
                  required: true,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("vacation-comment-field", {
                attrs: {
                  id: "vacation-comment",
                  name: "comments",
                  form: _vm.form,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col text-right" },
            [
              _c("vue-button", {
                staticClass: "btn-primary send-button",
                attrs: {
                  title: _vm.$t("pages.permission.vacations.send_request"),
                  loading: _vm.isLoading,
                },
                on: { click: _vm.sendRequest },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }